import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProviderCodeService {
  private http = inject(HttpClient);

  getProviderCodes() {
    return this.http.get<any>(environment.apiUrl + 'provider-codes');
  }
}
